// extracted by mini-css-extract-plugin
module.exports = {"footer":"AddTestForm_footer__2k7PG","formContainer":"AddTestForm_formContainer__O4w7z","addRow":"AddTestForm_addRow__eZxSK"};